import { render, staticRenderFns } from "./salarySuccessDtl.vue?vue&type=template&id=720e137c&scoped=true&"
import script from "./salarySuccessDtl.vue?vue&type=script&lang=js&"
export * from "./salarySuccessDtl.vue?vue&type=script&lang=js&"
import style0 from "./salarySuccessDtl.vue?vue&type=style&index=0&id=720e137c&prod&lang=scss&scoped=true&"
import style1 from "./salarySuccessDtl.vue?vue&type=style&index=1&id=720e137c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "720e137c",
  null
  
)

export default component.exports